import { create } from "zustand";

const useStore = create((set) =>({

    fonMenuDrawer: false,
    signActive:false,
    logActive:true,
    screenLoader:true,
    isAdminDashActive: true,
    isAItaskActive: false,
    isUserProfileActive: false,
    isContracts: false,
    adminLoader:true,
    isUserDashboardActive: true,
    isUserDashNavActive:false,
    isDesktopLeftDashActive:true,
    isDesktopRightDashActive:true,
    isDesktopLeftBottomActive:false,
    isJobUploadActive:false,
    userNavLinkActive:"Dashboard",
    leftProfActive:true,
    rightProfActive:true,
    isUserAccountSettings:false,
    isUserPaymentMethods:false,
    allUsersDrawer:false,
    trxnDetail:false,
    allAccountLevels: false, 
    isShowReVe:null,


    setAllAccountLevels: (ac) => set({ allAccountLevels: ac }),
    setShowReVe: (sr) => set({ isShowReVe: sr }),
    openFonMenu: () => set({fonMenuDrawer:true}),
    setTrxnDet:(std)=> set({trxnDetail:std}),
    
    closeFonMenu: () => set({fonMenuDrawer: false}),
    setAL: (ac) => set({ allAccountLevels: ac }),  // ✅ Add this function
    showLogAuth: () => set({logActive: true, signActive: false}), // Set both
    hideLogAuth: () => set({logActive: false}),
    showSignAuth: () => set({signActive: true, logActive: false}), // Set both
    hideSignAuth: () => set({signActive: false}),
    hideScreenLoader: () => set({screenLoader: false}),
    showScrenLoader: () =>set({screenLoader:true}),
    showAdminDashboard:() => set({allUsersDrawer:false,isAdminDashActive:true, isAItaskActive:false,isJobUploadActive:false,}),
    showAllUsers:() => set({allUsersDrawer:true, isAdminDashActive:false, isAItaskActive:false,isJobUploadActive:false,}),
    hideAdminDashboard: () => set({allUsersDrawer:false,isAdminDashActive:false,}),
    showAiTask:() => set({ isAItaskActive:true,allUsersDrawer:false, isAdminDashActive:false,isJobUploadActive:false,}),
    hideAiTask: () => set({isAItaskActive:false}),
    hideAllUsersDrawer: () => set({allUsersDrawer:false}),
    showJobUpload:() => set({isJobUploadActive:true,allUsersDrawer:false, isAItaskActive:false, isAdminDashActive:false}),
    hideJobUpload: () => set({showJobUpload:false}),
    showUserProfile: () => set({userNavLinkActive:"MyStats",isUserPaymentMethods:false,isUserAccountSettings:false,isUserProfileActive: true, isUserDashboardActive:false,rightProfActive:true, leftProfActive:true}),
    showUserDashboard: ()=> set({userNavLinkActive:"Dashboard",isUserPaymentMethods:false,isDesktopLeftBottomActive:false,isUserAccountSettings:false,isUserDashboardActive: true, isUserProfileActive:false, isDesktopLeftDashActive:true,isDesktopRightDashActive:true}),
    showContracts: ()=> set({userNavLinkActive:"Contracts",  isUserPaymentMethods:false,isContracts:true,isUserDashboardActive: true, isUserProfileActive:false,isUserAccountSettings:false}),
    showAiTasks: ()=> set({userNavLinkActive:"AI-Tasks",  isUserPaymentMethods:false,isDesktopLeftBottomActive:true,isContracts:false,isUserDashboardActive: true, isUserProfileActive:false}),
    hideUserDashboard: ()=> set({isUserDashboardActive: false}),
    hideUserDashNav: ()=> set({isUserDashNavActive: false}),
    showUserDashNav: ()=> set({isUserDashNavActive: true}),
    showDesktopLeftDash: ()=>set({isDesktopLeftDashActive:true, isDesktopRightDashActive:false}),
    hideDesktopLeftDash: ()=>set({isDesktopLeftDashActive:false, isDesktopRightDashActive:true}),
    showPayments:()=>set({isUserProfileActive:true,isUserAccountSettings:false,  isUserPaymentMethods:false, userNavLinkActive:"Wallet",isUserDashboardActive: false,leftProfActive:false,rightProfActive:true}),
    showPaymentMethod:()=>set({userNavLinkActive:"Payment Method",isUserPaymentMethods:true,isUserProfileActive:false,isUserAccountSettings:false,isUserDashboardActive: false,leftProfActive:false,rightProfActive:true}),
    showAccountStatus:()=>set({userNavLinkActive:"Account Status",isUserPaymentMethods:false,isUserAccountSettings:true,isUserProfileActive:false,isUserDashboardActive: false,leftProfActive:false,rightProfActive:true}),
    removeAdminLoader: ()=>set({adminLoader:false}),
    setAdminLoader: ()=>set({adminLoader:true})
}))

export default useStore;
